import React, { useState, useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import UnitCountFive from "../components/child/UnitCountFive";
import UnitCountOne from "../components/child/UnitCountOne";
import UnitCountQr from "../components/child/UnitCountQr";
import MasterLayout from "../masterLayout/MasterLayout";
import UsersOverviewOne from "../components/child/UsersOverviewOne";
import { retrieveData } from "../LocalConnection/LocalConnection";
import Modal from "react-bootstrap/Modal";

import TableDataLayer from "../components/TableDataLayer";
import {
  server_post_data,
  new_dashboard,
  refresh_platform_token,
} from "../ServiceConnection/serviceconnection";
import { handleError } from "../CommonJquery/CommonJquery";
import Loader from "./Loader";
import { useNavigate } from "react-router-dom";
const DashboardWow = () => {
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [reviewsTotal, setReviewTotal] = useState([]);
  const periodSelected = retrieveData("period");
  const navigate = useNavigate();
  console.log(periodSelected);

  const handleDateSelection = (start, end, period) => {
    try {
      console.log(start, end, period);
      setReviewTotal([]);
      master_data_get(start, end, period);
    } catch (error) {
      console.error("An error occurred in handleDropdownChange:", error);
    }
  };

  const master_data_get = async (start, end, period) => {
    setShowLoaderAdmin(true);
    let formdata = new FormData();
    formdata.append("from_date", start);
    formdata.append("to_date", end);
    formdata.append("click_type", period);
    await server_post_data(new_dashboard, formdata)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          console.log("Dash data", final_data);
          setReviewTotal(final_data);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  const master_data_get_refresh_token = async () => {
    let formdata = new FormData();
    await server_post_data(refresh_platform_token, formdata)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
          setShowModal(true);
          console.log("Hello Token Expired");
        } else {
          // master_data_get_update_all_platform_data();
          console.log("Token Fetched success");
        }
      })
      .catch((error) => {
        handleError("network");
      });
  };

  useEffect(() => {
    master_data_get("", "", periodSelected);
    master_data_get_refresh_token();
  }, []);

  useEffect(() => {
    handleDateSelection("", "", periodSelected);
  }, [periodSelected]);

  const handleShareShowClose = () => {
    // setshareModal(!shareModal);
    setShowModal(false);
  };

  const handleReconnect = () => {
    console.log("Reconnect button clicked");
    handleShareShowClose(); // Close the modal
    navigate("/Setup-Review-Channels", { state: { googleReconnect: true } });
  };
  // console.log(reviewsTotal)
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {ShowLoaderAdmin && <Loader />}
        {/* Breadcrumb */}
        <Breadcrumb title="Dashboard" onDateSelection={handleDateSelection} />
        <div className="Over_flow_height">
          <div className="row gy-4 mb-24">
            {reviewsTotal && reviewsTotal.total_reviews && (
              <UnitCountOne
                total_reviews={
                  parseInt(reviewsTotal.total_reviews.total_count)
                  //  + parseInt(reviewsTotal.total_reviews_positive.total_count)
                }
                total_reviews_last={reviewsTotal.total_reviews_last.total_count}
                total_reviews_positive={
                  reviewsTotal.total_reviews_positive.total_count
                }
                total_reviews_positive_last={
                  reviewsTotal.total_reviews_positive_last.total_count
                }
                total_reviews_positive_new={
                  reviewsTotal.total_reviews_positive_new.total_count
                }
                total_reviews_positive_last_new={
                  reviewsTotal.total_reviews_positive_last_new.total_count
                }
                total_reviews_negative={
                  reviewsTotal.total_reviews_negative.total_count
                }
                total_reviews_negative_last={
                  reviewsTotal.total_reviews_negative_last.total_count
                }
                total_reviews_third_party={
                  reviewsTotal.total_reviews_third_party
                }
                total_reviews_third_party_last={
                  reviewsTotal.total_reviews_third_party_last
                }
                total_click_type={reviewsTotal.click_type}
                has_comparison={reviewsTotal.has_comparison}
              />
            )}

            {reviewsTotal && reviewsTotal.total_reviews_list && (
              <UnitCountFive
                total_reviews_positive_loop={
                  reviewsTotal.total_reviews_positive_loop
                }
                total_reviews_positive_loop_new={
                  reviewsTotal.total_reviews_positive_loop_new
                }
                total_reviews_negative_loop={
                  reviewsTotal.total_reviews_negative_loop
                }
              />
            )}
            {/* Reviews by Platforms */}
            {reviewsTotal && reviewsTotal.total_reviews_third_party && (
              <UsersOverviewOne
                thirdPartyReviews={reviewsTotal.total_reviews_third_party}
              />
            )}
            {reviewsTotal && reviewsTotal.total_reviews && (
              <UnitCountQr
                total_qr_scans={reviewsTotal.total_qr_scans?.total_count ?? 0}
                positive={reviewsTotal.total_qr_scans?.positive_count ?? 0}
                negative={reviewsTotal.total_qr_scans?.negative_count ?? 0}
              />
            )}
          </div>
          {reviewsTotal && reviewsTotal.total_reviews_list && (
            <TableDataLayer data={reviewsTotal.total_reviews_list} />
          )}
        </div>
      </MasterLayout>
      <Modal
        show={showModal}
        onHide={handleShareShowClose}
        centered
        backdrop="static"
        className="share-modal"
        size="md"
      >
        <Modal.Header className="border-bottom d-flex justify-content-between align-items-center">
          <Modal.Title className="mb-0 newFOntModal">
            Google Disconnected
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={handleShareShowClose}
            aria-label="Close"
            style={{
              background: "none",
              border: "none",
              fontSize: "1.7rem",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </Modal.Header>
        <Modal.Body style={{ padding: "30px" }}>
          <div className="flex flex-col items-center">
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  border: "3px solid #4B5EAA",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <span
                  style={{
                    fontSize: "30px",
                    color: "#4B5EAA",
                    fontWeight: "bold",
                  }}
                >
                  !
                </span>
              </div>
            </div>
            <p
              style={{
                fontSize: "1.875rem",
                fontWeight: "800",
                color: "#EC5E3A",
                marginBottom: "16px",
                textAlign: "center",
              }}
            >
              Oh No !!
            </p>
            <p
              style={{
                color: "#4B5EAA",
                fontSize: "1rem",
                marginBottom: "16px",
                textAlign: "center",
              }}
            >
              Your Google My Business account has been Disconnected. Please
              reconnect your Google account to continue.
            </p>
            <button
              onClick={handleReconnect}
              style={{
                width: "100%",
                backgroundColor: "#EC5E3A",
                color: "white",
                padding: "12px 24px",
                borderRadius: "8px",
                fontSize: "1.125rem",
                fontWeight: "600",
                border: "none",
                cursor: "pointer",
                textAlign: "center",
              }}
            >
              Reconnect
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DashboardWow;
